var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "b-container",
        {
          staticClass: "flex-grow-1 d-flex flex-column h-100",
          attrs: { fluid: "" }
        },
        [
          _c(
            "b-collapse",
            { attrs: { id: "test", visible: false } },
            [
              _c("yandex-map", {
                staticClass: "my-3",
                staticStyle: { width: "10px", height: "10px" },
                attrs: { coords: [57.13717, 65.546001], zoom: "12" },
                on: { "map-was-initialized": _vm.backgroundMap }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "flex-grow-1" },
            [
              _c(
                "b-col",
                { staticClass: "d-flex flex-column h-100", attrs: { md: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "flex-grow-1 d-flex flex-column",
                      attrs: { "no-body": "" }
                    },
                    [
                      _c(
                        "b-tabs",
                        {
                          staticClass: "flex-grow-1 d-flex flex-column h-100",
                          attrs: {
                            card: "",
                            "content-class":
                              "d-flex flex-column flex-grow-1 flex-tab"
                          },
                          model: {
                            value: _vm.tabIndex,
                            callback: function($$v) {
                              _vm.tabIndex = _vm._n($$v)
                            },
                            expression: "tabIndex"
                          }
                        },
                        _vm._l(Object.keys(_vm.brandsOptions), function(
                          index,
                          item
                        ) {
                          return _c(
                            "b-tab",
                            {
                              key: item.id,
                              staticClass: "px-0 py-0 flex-grow-1 h-100",
                              attrs: {
                                title: _vm.brandsOptions[index].name,
                                disabled:
                                  _vm.readonly === true &&
                                  _vm.tabIndex !== parseInt(index)
                              },
                              on: {
                                click: function($event) {
                                  _vm.catId = null
                                }
                              }
                            },
                            [
                              _c(
                                "b-list-group",
                                {
                                  staticClass: "flex-shrink-0",
                                  attrs: { flush: "" }
                                },
                                [
                                  _c("b-list-group-item", [
                                    _c(
                                      "div",
                                      { staticClass: "categories" },
                                      [
                                        _vm.brandsOptions[_vm.tabIndex] !==
                                        undefined
                                          ? _vm._l(
                                              Object.keys(
                                                _vm.brandsOptions[_vm.tabIndex]
                                                  .cats.nodes
                                              ),
                                              function(category) {
                                                return _c(
                                                  "b-card",
                                                  {
                                                    key: category,
                                                    staticClass:
                                                      "text-center mx-1",
                                                    class: [
                                                      {
                                                        active:
                                                          _vm.catId === category
                                                      },
                                                      "px-1",
                                                      "mb-1",
                                                      "justify-content-between"
                                                    ],
                                                    attrs: { "no-body": "" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleCategory(
                                                          category
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.brandsOptions[
                                                            _vm.tabIndex
                                                          ].cats.nodes[category]
                                                            .name
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-card-body",
                                {
                                  staticClass:
                                    "flex-grow-1 d-flex flex-column pr-1 pl-0 pt-3"
                                },
                                [
                                  _vm.catId === null
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [_vm._v("Выберите категорию")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.catId !== null && _vm.countProds === 0
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _vm._v(
                                            "В выбранной категории нет товаров"
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-input-group",
                                    {
                                      staticClass:
                                        "pr-4 mb-2 pl-4 flex-shrink-0"
                                    },
                                    [
                                      _vm.countProds > 0
                                        ? [
                                            _c("b-form-input", {
                                              staticClass: "brunch__text_input",
                                              attrs: {
                                                placeholder:
                                                  "Введите для поиска"
                                              },
                                              model: {
                                                value: _vm.filterProd,
                                                callback: function($$v) {
                                                  _vm.filterProd = $$v
                                                },
                                                expression: "filterProd"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "transition",
                                              { attrs: { name: "slide-fade" } },
                                              [
                                                _vm.filterProd.length
                                                  ? _c(
                                                      "b-input-group-append",
                                                      [
                                                        _c(
                                                          "b-btn",
                                                          {
                                                            attrs: {
                                                              disabled: !_vm.filterProd
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.filterProd =
                                                                  ""
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Очистить")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.filterProds !== null &&
                                            _vm.filterProds.length === 0
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mt-2 w-100" },
                                                  [
                                                    _vm._v(
                                                      "Не\n                                            найдено продуктов по фильтру\n                                        "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "perfect-scrollbar",
                                    {
                                      staticClass:
                                        "flex-basis-0 flex-grow-1 h-100",
                                      attrs: { options: _vm.opsScroll }
                                    },
                                    [
                                      _c(
                                        "transition",
                                        {
                                          attrs: {
                                            name: "slide-fade-from-bottom"
                                          }
                                        },
                                        [
                                          _vm.countProds > 0
                                            ? _c(
                                                "b-card-group",
                                                {
                                                  staticClass:
                                                    "grid grid-3 products pr-4 pl-4 pb-1",
                                                  attrs: { id: "products" }
                                                },
                                                _vm._l(
                                                  _vm.filterProds,
                                                  function(prod) {
                                                    return _c(
                                                      "b-card",
                                                      {
                                                        key: prod.idProduct,
                                                        staticClass:
                                                          "text-center my-1 prod",
                                                        attrs: {
                                                          "no-body": ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addProd(
                                                              prod
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "b-tooltip",
                                                                rawName:
                                                                  "v-b-tooltip.hover",
                                                                modifiers: {
                                                                  hover: true
                                                                }
                                                              }
                                                            ],
                                                            staticClass:
                                                              "px-1 py-1 d-flex flex-column h-100 justify-content-center",
                                                            attrs: {
                                                              id:
                                                                "prod" +
                                                                prod.idProduct,
                                                              title:
                                                                prod.description
                                                            }
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  prod.name
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "sub-info"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    prod.cost
                                                                  ) + " ₽"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex flex-column justify-content-between h-100",
                  attrs: { md: !_vm.ordersWindowVisibility ? 9 : 6 }
                },
                [
                  _vm.loadingCheckOrderIndicator
                    ? [
                        _c(
                          "b-card",
                          {
                            staticClass: "flex-grow-1",
                            attrs: {
                              "body-class":
                                "text-center d-flex flex-column justify-content-center"
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _vm._v("Проверка доступности заказа "),
                                _c("b-spinner", { staticClass: "ml-1" })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    : [
                        !_vm.order
                          ? [
                              _c(
                                "b-card",
                                {
                                  staticClass: "flex-grow-1",
                                  attrs: {
                                    "body-class":
                                      "text-center d-flex flex-column justify-content-center"
                                  }
                                },
                                [
                                  _c("div", [
                                    _vm._v("Выберите заказ или создайте новый")
                                  ])
                                ]
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.order
                          ? [
                              _c(
                                "b-card",
                                {
                                  staticClass: "flex-grow-1 mb-1",
                                  attrs: {
                                    "header-class": [
                                      _vm.readonly ? "confirmOrder" : ""
                                    ],
                                    "no-body": ""
                                  }
                                },
                                [
                                  _c(
                                    "h6",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center mb-0",
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.order.id
                                              ? "Заказ #" + _vm.order.idDay
                                              : "Новый заказ"
                                          ) + ":"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "px-2 py-0 pb-1 button-brunch",
                                          attrs: {
                                            disabled: this.loadingProducts,
                                            variant: "danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.changeOrder()
                                            }
                                          }
                                        },
                                        [
                                          _c("icon", {
                                            attrs: { name: "times" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group",
                                    {
                                      staticClass:
                                        "flex-grow-1 justify-content-between d-flex",
                                      attrs: { flush: "", id: "orderProd" }
                                    },
                                    [
                                      _c(
                                        "perfect-scrollbar",
                                        {
                                          staticClass:
                                            "flex-basis-0 flex-grow-1",
                                          attrs: { options: _vm.opsScroll }
                                        },
                                        [
                                          _c("b-table", {
                                            staticClass: "mb-0 table-orders",
                                            attrs: {
                                              hover: "",
                                              "show-empty": "",
                                              "empty-text": _vm.emptyTextProds,
                                              fields: _vm.fields,
                                              items: _vm.orderProds,
                                              busy: _vm.loadingProducts,
                                              "tbody-class": "scroll-y",
                                              "tbody-tr-class": "order-prods"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "table-busy",
                                                  fn: function() {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-items-center justify-content-center mt-2"
                                                        },
                                                        [
                                                          _c("b-spinner", {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              type: "border",
                                                              variant: "dark",
                                                              small: ""
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "Загрузка..."
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                },
                                                {
                                                  key: "cost",
                                                  fn: function(data) {
                                                    return [
                                                      !data.item.promocodeItem
                                                        ? _c("div", [
                                                            _vm._v(
                                                              "\n                                              " +
                                                                _vm._s(
                                                                  data.item
                                                                    .cost > 0 ||
                                                                    data.item
                                                                      .pricePoints ===
                                                                      undefined ||
                                                                    data.item
                                                                      .pricePoints ===
                                                                      0
                                                                    ? parseInt(
                                                                        data
                                                                          .item
                                                                          .cost
                                                                      ) + " Р"
                                                                    : data.item
                                                                        .pricePoints +
                                                                        " Б"
                                                                ) +
                                                                "\n                                          "
                                                            )
                                                          ])
                                                        : _c(
                                                            "div",
                                                            [
                                                              _c("icon", {
                                                                staticClass:
                                                                  "promocode-icon",
                                                                attrs: {
                                                                  name: "gift"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "summary",
                                                  fn: function(data) {
                                                    return [
                                                      !data.item.promocodeItem
                                                        ? _c("div", [
                                                            _vm._v(
                                                              "\n                                              " +
                                                                _vm._s(
                                                                  data.item
                                                                    .cost > 0 ||
                                                                    data.item
                                                                      .pricePoints ===
                                                                      undefined ||
                                                                    data.item
                                                                      .pricePoints ===
                                                                      0
                                                                    ? _vm.summaryWithGroup(
                                                                        data.item
                                                                      ) + " Р"
                                                                    : _vm.summaryWithGroup(
                                                                        data.item,
                                                                        true
                                                                      ) + " Б"
                                                                ) +
                                                                "\n                                          "
                                                            )
                                                          ])
                                                        : _c(
                                                            "div",
                                                            [
                                                              _c("icon", {
                                                                staticClass:
                                                                  "promocode-icon",
                                                                attrs: {
                                                                  name: "gift"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "nameProd",
                                                  fn: function(data) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            id:
                                                              "orderProd" +
                                                              data.item.index
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "description"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data.item.name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            data.item
                                                              .groupProds,
                                                            function(add) {
                                                              return _c(
                                                                "b-badge",
                                                                {
                                                                  key:
                                                                    add.index,
                                                                  staticClass:
                                                                    "mr-1"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      add.name
                                                                    ) +
                                                                      _vm._s(
                                                                        add.cost >
                                                                          0
                                                                          ? " (" +
                                                                              add.cost +
                                                                              " ₽)"
                                                                          : ""
                                                                      ) +
                                                                      "\n                                              "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          data.item.prod
                                                            .pizzaSize ||
                                                          data.item.prod.burger
                                                            ? _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  staticClass:
                                                                    "checkbox-header",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readonly,
                                                                    value: true,
                                                                    "unchecked-value": false
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.changedPositionSize(
                                                                        data.item
                                                                      )
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      data.item
                                                                        .smallSize,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        data.item,
                                                                        "smallSize",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "data.item.smallSize"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                  " +
                                                                      _vm._s(
                                                                        data
                                                                          .item
                                                                          .prod
                                                                          .burger
                                                                          ? "свинина"
                                                                          : "на тонком тесте"
                                                                      ) +
                                                                      "\n                                              "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c("b-tooltip", {
                                                        attrs: {
                                                          target:
                                                            "orderProd" +
                                                            data.item.index,
                                                          placement: "right",
                                                          title:
                                                            data.item.prod
                                                              .description
                                                        }
                                                      })
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "prodAdd",
                                                  fn: function(data) {
                                                    return [
                                                      _vm.allDop.get(
                                                        data.item.prod
                                                          ? data.item.prod
                                                              .idCategory
                                                          : data.item.idCategory
                                                      )
                                                        ? _c(
                                                            "b-button",
                                                            {
                                                              staticClass:
                                                                "px-2 py-0 pb-1 round-btn",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.readonly,
                                                                variant: "info"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.openModalProducts(
                                                                    data.item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("icon", {
                                                                attrs: {
                                                                  name: "plus"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "countNum",
                                                  fn: function(data) {
                                                    return [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "px-2 py-0 pb-1 round-btn",
                                                          attrs: {
                                                            disabled:
                                                              (data.item.cost ==
                                                                0 &&
                                                                data.item
                                                                  .pricePoints !==
                                                                  undefined) ||
                                                              _vm.readonly,
                                                            variant:
                                                              "outline-danger"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.changeProdCount(
                                                                data.item,
                                                                -1
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("icon", {
                                                            attrs: {
                                                              name: "minus"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "two-digit-inp align-middle",
                                                        attrs: {
                                                          disabled:
                                                            (data.item.cost ==
                                                              0 &&
                                                              data.item
                                                                .pricePoints !==
                                                                undefined) ||
                                                            _vm.readonly,
                                                          type: "number",
                                                          min: "0",
                                                          max: "99"
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            return _vm.changedProdCount(
                                                              data.item
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            data.item.count,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              data.item,
                                                              "count",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "data.item.count"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "px-2 py-0 pb-1 round-btn",
                                                          attrs: {
                                                            disabled:
                                                              (data.item.cost ==
                                                                0 &&
                                                                data.item
                                                                  .pricePoints !==
                                                                  undefined) ||
                                                              _vm.readonly,
                                                            variant:
                                                              "outline-success"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.changeProdCount(
                                                                data.item,
                                                                1
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("icon", {
                                                            attrs: {
                                                              name: "plus"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "delete",
                                                  fn: function(data) {
                                                    return [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "px-2 py-0 pb-1 mr-2 button-brunch",
                                                          attrs: {
                                                            variant: "danger"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.delProd(
                                                                data.item.index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("icon", {
                                                            attrs: {
                                                              name: "trash-alt"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              1327531555
                                            )
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("add-additional-products", {
                                        attrs: {
                                          vuexNamespace: _vm.vuexNamespace,
                                          product: _vm.productInEditing,
                                          showed:
                                            _vm.openedModalAdditionalProducts,
                                          allDops: _vm.allDop
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-list-group-item",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center flex-shrink-0 flex-wrap pt-1"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-100 d-flex justify-content-between align-items-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "priceOrder mr-2"
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v("Итого: "),
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(_vm.orderPrice) +
                                                          " ₽ " +
                                                          _vm._s(
                                                            _vm.orderPricePoints !==
                                                              0
                                                              ? "(" +
                                                                  _vm.orderPricePoints +
                                                                  " Б)"
                                                              : ""
                                                          )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _vm.discountValue !== 0
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _vm._v(" - "),
                                                            _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.discountValue
                                                                ) + " ₽"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _vm.order
                                                              .discountType ===
                                                            0
                                                              ? [
                                                                  _vm._v(" ("),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .order
                                                                          .discountValue
                                                                      ) + "%"
                                                                    )
                                                                  ]),
                                                                  _vm._v(")")
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e()
                                                  ]),
                                                  _vm._v(" "),
                                                  parseInt(
                                                    _vm.order
                                                      .clientPriceDelivery
                                                  )
                                                    ? _c("div", [
                                                        _vm._v("Доставка: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              parseInt(
                                                                _vm.order
                                                                  .clientPriceDelivery
                                                              )
                                                            ) +
                                                              "\n                                              ₽"
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      key: _vm.getRealOrderPrice()
                                                    },
                                                    [
                                                      _vm._v("К оплате: "),
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getRealOrderPrice()
                                                          ) + " ₽"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-1 mr-4",
                                                  attrs: {
                                                    "label-size": "sm",
                                                    label: "Скидка:"
                                                  }
                                                },
                                                [
                                                  _c("b-form-select", {
                                                    key:
                                                      _vm.randomDiscountTypeUpdate,
                                                    attrs: {
                                                      value:
                                                        _vm.orderTypeDiscount,
                                                      options:
                                                        _vm.selectDiscount,
                                                      disabled: _vm.collected
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.setTypeDiscount(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass:
                                                    "mb-1 mr-4 flex-shrink-0",
                                                  attrs: {
                                                    "label-size": "sm",
                                                    label: "Размер скидки:"
                                                  }
                                                },
                                                [
                                                  _c("b-input", {
                                                    attrs: {
                                                      type: "number",
                                                      placeholder:
                                                        "Размер скидки",
                                                      min: "0",
                                                      disabled:
                                                        _vm.order.discountType
                                                          .keyword ===
                                                          _vm.constDiscount
                                                            .POINTS ||
                                                        _vm.blockDiscountChange ||
                                                        _vm.collected
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.order.discountValue,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.order,
                                                          "discountValue",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "order.discountValue"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-1 mr-4",
                                                  attrs: {
                                                    "label-size": "sm",
                                                    label: "Персон:"
                                                  }
                                                },
                                                [
                                                  _c("b-input", {
                                                    attrs: {
                                                      type: "number",
                                                      placeholder:
                                                        "Кол-во персон",
                                                      disabled: _vm.collected,
                                                      min: "0"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.order.personNumber,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.order,
                                                          "personNumber",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "order.personNumber"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-1",
                                                  attrs: {
                                                    "label-size": "sm",
                                                    label: "Время:"
                                                  }
                                                },
                                                [
                                                  _c("el-time-select", {
                                                    staticClass:
                                                      "inputSize w-100",
                                                    attrs: {
                                                      disabled: _vm.readonly,
                                                      format: "HH:mm",
                                                      "picker-options": {
                                                        start: "9:00",
                                                        step: "00:15",
                                                        end: "23:45"
                                                      },
                                                      placeholder: "На время"
                                                    },
                                                    model: {
                                                      value: _vm.order.forTime,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.order,
                                                          "forTime",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "order.forTime"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-between w-100"
                                            },
                                            [
                                              _c("modal-add-payment", {
                                                key: _vm.getRealOrderPrice(),
                                                attrs: {
                                                  order: _vm.order,
                                                  orderSum: _vm.getRealOrderPrice(),
                                                  readonly: _vm.readonly,
                                                  typesPayment:
                                                    _vm.selectTypePayment
                                                },
                                                on: {
                                                  "disable-not-correct-sum":
                                                    _vm.disableConfirmByPayment,
                                                  updatePaymentOnlyInfo:
                                                    _vm.updatePaymentOnlyInfo,
                                                  updateTypePaymentCombined:
                                                    _vm.updateTypePaymentCombined
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass:
                                                    "mb-0 ml-2 change",
                                                  attrs: {
                                                    "label-size": "sm",
                                                    label: "Сдача с:",
                                                    "label-class": "mb-0",
                                                    "label-for": "InputChange"
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "InputChange",
                                                      disabled:
                                                        (_vm.order.typePayment
                                                          .keyword !==
                                                          _vm.constPayment
                                                            .CASH &&
                                                          _vm.order.typePayment
                                                            .keyword !==
                                                            _vm.constPayment
                                                              .COMBO) ||
                                                        _vm.readonly,
                                                      type: "number",
                                                      min: "0",
                                                      required: "",
                                                      placeholder: "Сдача с"
                                                    },
                                                    model: {
                                                      value: _vm.order.change,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.order,
                                                          "change",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "order.change"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass:
                                                    "mb-0 ml-2 flex-grow-1",
                                                  attrs: {
                                                    "label-size": "sm",
                                                    label: "Промокод:"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-select",
                                                    {
                                                      key:
                                                        _vm.randomPromocodeUpdate,
                                                      attrs: {
                                                        disabled: _vm.readonly,
                                                        label: "title",
                                                        options:
                                                          _vm.promocodeOptions
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.selectPromocode
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "option",
                                                            fn: function(
                                                              option
                                                            ) {
                                                              return [
                                                                _c("div", {
                                                                  class: [
                                                                    {
                                                                      promocodeOnlyMobile:
                                                                        option.onlyMobile
                                                                    }
                                                                  ],
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      option.title
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        825861333
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.orderPromocode,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.orderPromocode = $$v
                                                        },
                                                        expression:
                                                          "orderPromocode"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "no-options"
                                                          },
                                                          slot: "no-options"
                                                        },
                                                        [_vm._v("Не найдено")]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass:
                                                    "mb-0 ml-2 flex-grow-0",
                                                  attrs: {
                                                    "label-size": "sm",
                                                    label: "День:"
                                                  }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    attrs: {
                                                      disabled: _vm.readonly,
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      format: "dd.MM.yyyy",
                                                      "picker-options":
                                                        _vm.datePickerOptions,
                                                      type: "date",
                                                      placeholder:
                                                        "Выбрать день"
                                                    },
                                                    model: {
                                                      value: _vm.order.forDay,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.order,
                                                          "forDay",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "order.forDay"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex w-100" },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass:
                                                    "mb-0 flex-grow-1 mt-2 w-100",
                                                  attrs: {
                                                    label:
                                                      "Комментарий курьеру:",
                                                    "label-for": "InputComment"
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "InputComment",
                                                      required: "",
                                                      placeholder:
                                                        "Комментарий курьеру"
                                                    },
                                                    model: {
                                                      value: _vm.order.comment,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.order,
                                                          "comment",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "order.comment"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass:
                                                    "mb-0 flex-grow-1 mt-2 w-100 ml-2",
                                                  attrs: {
                                                    label:
                                                      "Комментарий на кухню:",
                                                    "label-for":
                                                      "InputKitchenComment"
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "InputKitchenComment",
                                                      required: "",
                                                      placeholder:
                                                        "Комментарий на кухню"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.order
                                                          .kitchenComment,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.order,
                                                          "kitchenComment",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "order.kitchenComment"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "flex-shrink-0" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "7" } },
                                    [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "my-1",
                                          attrs: {
                                            "no-body": "",
                                            "header-class": [
                                              _vm.readonly ? "confirmOrder" : ""
                                            ]
                                          }
                                        },
                                        [
                                          _c(
                                            "h6",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between align-items-center mb-0",
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  "Доставка:\n                                      (" +
                                                    _vm._s(_vm.priceDel) +
                                                    ")"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-checkbox",
                                                {
                                                  staticClass:
                                                    "checkbox-header",
                                                  attrs: {
                                                    id: "checkbox1",
                                                    value: _vm.deliveryOptions.find(
                                                      function(el) {
                                                        return (
                                                          el.keyword ===
                                                          _vm.constDelivery
                                                            .PICKUP
                                                        )
                                                      }
                                                    ),
                                                    "unchecked-value": _vm.deliveryOptions.find(
                                                      function(el) {
                                                        return (
                                                          el.keyword ===
                                                          _vm.constDelivery
                                                            .DELIVERY
                                                        )
                                                      }
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.order.typeDelivery,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.order,
                                                        "typeDelivery",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "order.typeDelivery"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                          Самовывоз\n                                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-list-group",
                                            { attrs: { flush: "" } },
                                            [
                                              _c(
                                                "b-list-group-item",
                                                [
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "12" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                              attrs: {
                                                                id:
                                                                  "InputGroup1",
                                                                "label-size":
                                                                  "sm",
                                                                "label-class":
                                                                  "mb-0",
                                                                label:
                                                                  "Населённый пункт:",
                                                                "label-for":
                                                                  "Input0"
                                                              }
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.order
                                                                        .city,
                                                                    expression:
                                                                      "order.city"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control",
                                                                attrs: {
                                                                  type: "text",
                                                                  disabled: !_vm.allowEditAddress
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.order
                                                                      .city
                                                                },
                                                                on: {
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm.order,
                                                                      "city",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "12" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                              attrs: {
                                                                id:
                                                                  "InputGroup1",
                                                                "label-size":
                                                                  "sm",
                                                                "label-class":
                                                                  "mb-0",
                                                                label: "Улица:",
                                                                "label-for":
                                                                  "Input1"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "vue-bootstrap-typeahead",
                                                                {
                                                                  attrs: {
                                                                    value: _vm.createAddressQuery(),
                                                                    maxMatches: 3,
                                                                    disabled: !_vm.allowEditAddress,
                                                                    data:
                                                                      _vm.possibleStreets,
                                                                    inputClass:
                                                                      _vm.streetError &&
                                                                      "border border-danger mb-1",
                                                                    placeholder:
                                                                      "Введите улицу"
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.onInputAddress,
                                                                    focus:
                                                                      _vm.onInputAddress,
                                                                    hit:
                                                                      _vm.onAddressHit
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.streetError
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "street-error"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.streetError
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "3" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                              attrs: {
                                                                id:
                                                                  "InputGroup3",
                                                                "label-size":
                                                                  "sm",
                                                                label:
                                                                  "Подъезд:",
                                                                "label-class":
                                                                  "mb-0",
                                                                "label-for":
                                                                  "Input3"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "Input3",
                                                                    disabled: !_vm.allowEditAddress,
                                                                    required:
                                                                      "",
                                                                    placeholder:
                                                                      "Подъезд"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.order
                                                                        .entrance,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.order,
                                                                        "entrance",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "order.entrance"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "3" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                              attrs: {
                                                                id:
                                                                  "InputGroup4",
                                                                "label-size":
                                                                  "sm",
                                                                label: "Этаж:",
                                                                "label-class":
                                                                  "mb-0",
                                                                "label-for":
                                                                  "Input4"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "Input4",
                                                                    disabled: !_vm.allowEditAddress,
                                                                    required:
                                                                      "",
                                                                    placeholder:
                                                                      "Этаж"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.order
                                                                        .floor,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.order,
                                                                        "floor",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "order.floor"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "3" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                              attrs: {
                                                                id:
                                                                  "InputGroup5",
                                                                "label-size":
                                                                  "sm",
                                                                label: "Кв:",
                                                                "label-class":
                                                                  "mb-0",
                                                                "label-for":
                                                                  "Input5"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "Input5",
                                                                    disabled: !_vm.allowEditAddress,
                                                                    required:
                                                                      "",
                                                                    placeholder:
                                                                      "Квартира"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.order
                                                                        .apartment,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.order,
                                                                        "apartment",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "order.apartment"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "3" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                              attrs: {
                                                                id:
                                                                  "InputGroup6",
                                                                "label-size":
                                                                  "sm",
                                                                label: "Офис:",
                                                                "label-class":
                                                                  "mb-0",
                                                                "label-for":
                                                                  "Input6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "Input6",
                                                                    disabled: !_vm.allowEditAddress,
                                                                    required:
                                                                      "",
                                                                    placeholder:
                                                                      "Офис"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.order
                                                                        .office,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.order,
                                                                        "office",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "order.office"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex flex-column",
                                      attrs: { md: "5" }
                                    },
                                    [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "my-1",
                                          attrs: {
                                            "no-body": "",
                                            "header-tag": "b",
                                            header: "Клиент:",
                                            "header-class": [
                                              _vm.readonly ? "confirmOrder" : ""
                                            ]
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between align-items-center",
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c("b", [_vm._v("Клиент:")]),
                                              _vm._v(" "),
                                              _c(
                                                "client-info-with-open-button",
                                                {
                                                  attrs: {
                                                    clientIdent: _vm.clientIdent
                                                  },
                                                  on: {
                                                    "update:client-order": function(
                                                      $event
                                                    ) {
                                                      return _vm.changeClient(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                }
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-list-group",
                                            { attrs: { flush: "" } },
                                            [
                                              _c(
                                                "b-list-group-item",
                                                [
                                                  _vm.order.client
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex justify-content-between align-items-center"
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.order
                                                                    .client &&
                                                                    _vm.order
                                                                      .client
                                                                      .name
                                                                    ? _vm.order
                                                                        .client
                                                                        .name
                                                                    : "Не указано"
                                                                )
                                                              )
                                                            ]),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.order
                                                                    .client
                                                                    ? _vm.order
                                                                        .client
                                                                        .phone
                                                                    : ""
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _vm.order.id ===
                                                            null
                                                              ? _c(
                                                                  "b-button",
                                                                  {
                                                                    staticClass:
                                                                      "px-2 py-0 pb-1",
                                                                    attrs: {
                                                                      variant:
                                                                        "info"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.order.phone = _vm.order.phone.substr(
                                                                          0,
                                                                          _vm
                                                                            .order
                                                                            .phone
                                                                            .length -
                                                                            1
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("icon", {
                                                                      attrs: {
                                                                        name:
                                                                          "edit"
                                                                      }
                                                                    })
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : !_vm.order.client &&
                                                      (!_vm.order.phone ||
                                                        _vm.order.phone.length <
                                                          17 ||
                                                        (_vm.order.phone
                                                          .length >= 2 &&
                                                          (_vm.order
                                                            .phone[3] !== "9" &&
                                                            _vm.order
                                                              .phone[3] !==
                                                              "3")))
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex justify-content-between"
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.readonly,
                                                                placeholder:
                                                                  "Имя"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.order.fio,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.order,
                                                                    "fio",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "order.fio"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("the-mask", {
                                                              staticClass:
                                                                "pl-2 pr-2 mr-2",
                                                              attrs: {
                                                                masked: true,
                                                                disabled:
                                                                  _vm.readonly,
                                                                mask:
                                                                  "8 (###) ###-##-##",
                                                                placeholder:
                                                                  "8 (###) ##-##-##"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.order
                                                                    .phone,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.order,
                                                                    "phone",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "order.phone"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : [
                                                        !_vm.order.client &&
                                                        _vm.order.phone &&
                                                        _vm.order.phone
                                                          .length == 17
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex justify-content-between align-items-center"
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.order
                                                                        .fio
                                                                        ? _vm
                                                                            .order
                                                                            .fio
                                                                        : "Не указано"
                                                                    ) +
                                                                      " (Не авториз.)"
                                                                  )
                                                                ]),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.order
                                                                        .phone
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                !_vm.readonly
                                                                  ? _c(
                                                                      "b-button",
                                                                      {
                                                                        staticClass:
                                                                          "px-2 py-0 pb-1",
                                                                        attrs: {
                                                                          variant:
                                                                            "info"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.order.phone = _vm.order.phone.substr(
                                                                              0,
                                                                              _vm
                                                                                .order
                                                                                .phone
                                                                                .length -
                                                                                1
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "icon",
                                                                          {
                                                                            attrs: {
                                                                              name:
                                                                                "edit"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ]
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "my-1",
                                          attrs: {
                                            "no-body": "",
                                            "header-class": [
                                              _vm.readonly ? "confirmOrder" : ""
                                            ]
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between align-items-center",
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c("b", [_vm._v("Точка:")]),
                                              _vm._v(" "),
                                              _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-modal",
                                                      rawName:
                                                        "v-b-modal.deliveryMap",
                                                      modifiers: {
                                                        deliveryMap: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass: "px-2 py-0 pb-1",
                                                  attrs: {
                                                    disabled:
                                                      (_vm.readonly &&
                                                        this.order
                                                          .ymapsDistance !==
                                                          null) ||
                                                      (this.order
                                                        .typeDelivery &&
                                                        this.order.typeDelivery
                                                          .keyword ===
                                                          _vm.constDelivery
                                                            .PICKUP) ||
                                                      _vm.order.street
                                                        .length === 0,
                                                    size: "sm",
                                                    variant: "info"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                          Определить\n                                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-list-group",
                                            { attrs: { flush: "" } },
                                            [
                                              _c(
                                                "b-list-group-item",
                                                [
                                                  _c(
                                                    "v-select",
                                                    {
                                                      attrs: {
                                                        label: "address",
                                                        options:
                                                          _vm.branchOptions,
                                                        "append-to-body": "",
                                                        "calculate-position":
                                                          _vm.withPopper
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "option",
                                                            fn: function(
                                                              option
                                                            ) {
                                                              return [
                                                                _c("div", {
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      option.address
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        357460814
                                                      ),
                                                      model: {
                                                        value: _vm.order.point,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.order,
                                                            "point",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "order.point"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "no-options"
                                                          },
                                                          slot: "no-options"
                                                        },
                                                        [_vm._v("Не найдено")]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ],
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-shrink-0 justify-content-between"
                    },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "flex-grow-1 mt-2",
                          attrs: {
                            disabled: _vm.loadingOrders,
                            variant: "outline-primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.changeOrder(_vm.copyObj(_vm.emptyOrder))
                            }
                          }
                        },
                        [_vm._v("Новый заказ\n                    ")]
                      ),
                      _vm._v(" "),
                      _vm.permitCancelOrder && !_vm.isRestManager
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "flex-grow-1 ml-1  mt-2",
                              attrs: {
                                variant: "danger",
                                disabled:
                                  !_vm.order ||
                                  !_vm.order.id ||
                                  _vm.loadingOrders
                              },
                              on: { click: _vm.cancelOrder }
                            },
                            [_vm._v("Отменить\n                    ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.readonly &&
                      _vm.permitCancelOrder &&
                      !_vm.isRestManager
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "flex-grow-1 ml-1  mt-2",
                              attrs: {
                                disabled: _vm.loadingOrders,
                                variant: "warning"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.cancelOrderRepeat()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "Отменить и повторить\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.readonly &&
                      _vm.permitCancelOrder &&
                      this.order.priority === 0
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "flex-grow-1 ml-1  mt-2",
                              attrs: { disabled: _vm.loadingOrders },
                              on: {
                                click: function($event) {
                                  return _vm.importantOrder(_vm.order)
                                }
                              }
                            },
                            [_vm._v("Срочно!\n                    ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.readonly && !_vm.permitCancelOrder) ||
                      (_vm.readonly && _vm.permitCancelOrder)
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "flex-grow-1 ml-1  mt-2",
                              attrs: {
                                disabled: _vm.loadingOrders,
                                variant: "warning"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.changeOrderRep(
                                    _vm.order,
                                    _vm.order.id
                                  )
                                }
                              }
                            },
                            [_vm._v("Повторить\n                    ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permitCancelOrder
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "flex-grow-1 ml-1  mt-2",
                              attrs: {
                                variant: "success",
                                disabled:
                                  !this.order ||
                                  !_vm.permitSaveOrder ||
                                  _vm.disableConfirmPayment ||
                                  _vm.loadingOrders ||
                                  _vm.orderInProcessOfSaving
                              },
                              on: {
                                click: function($event) {
                                  return _vm.editOrder()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.readonly ? "Сохранить" : "Подтвердить"
                                )
                              ),
                              _vm.orderInProcessOfSaving
                                ? _c("b-spinner", {
                                    staticClass: "ml-1",
                                    attrs: { small: "" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              ),
              _vm._v(" "),
              _vm.ordersWindowVisibility
                ? _c(
                    "b-col",
                    {
                      staticClass: "d-flex flex-column h-100",
                      attrs: { md: "3" }
                    },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "flex-grow-1 overflow-hidden",
                          attrs: { "no-body": "", "header-class": "py-2" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                              attrs: { slot: "header" },
                              slot: "header"
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass: "orders-count-title",
                                  attrs: { title: "Отобразить все заказы" },
                                  on: { click: _vm.showAllOrders }
                                },
                                [
                                  _c("b", [
                                    _vm._v("Заказы "),
                                    _c(
                                      "span",
                                      { attrs: { id: "orders-length" } },
                                      [_vm._v(_vm._s(_vm.filterOrds.length))]
                                    ),
                                    _vm._v(" из "),
                                    _c(
                                      "span",
                                      { attrs: { id: "orders-total-length" } },
                                      [_vm._v(_vm._s(_vm.ordersCount))]
                                    ),
                                    _vm._v(":")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                [
                                  _c("el-button", {
                                    directives: [
                                      {
                                        name: "b-toggle",
                                        rawName: "v-b-toggle.collapseOrders",
                                        modifiers: { collapseOrders: true }
                                      }
                                    ],
                                    staticClass: "no-outline",
                                    attrs: {
                                      icon: "el-icon-search",
                                      size: "medium",
                                      circle: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-button", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.topleft",
                                        modifiers: {
                                          hover: true,
                                          topleft: true
                                        }
                                      }
                                    ],
                                    staticClass: "no-outline",
                                    attrs: {
                                      icon: "el-icon-refresh",
                                      size: "medium",
                                      title: "Обновить список заказов",
                                      circle: ""
                                    },
                                    on: { click: _vm.forceReloadOrders }
                                  }),
                                  _vm._v(" "),
                                  _c("el-button", {
                                    directives: [
                                      {
                                        name: "b-modal",
                                        rawName: "v-b-modal.listOrders",
                                        modifiers: { listOrders: true }
                                      }
                                    ],
                                    staticClass: "no-outline",
                                    attrs: {
                                      icon: "el-icon-tickets",
                                      type: "primary",
                                      size: "medium",
                                      circle: ""
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            { attrs: { id: "collapseOrders" } },
                            [
                              _c(
                                "b-list-group",
                                { attrs: { flush: "" } },
                                [
                                  _c(
                                    "b-list-group-item",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-1",
                                          attrs: {
                                            horizontal: "",
                                            label: "Поиск"
                                          }
                                        },
                                        [
                                          _c(
                                            "b-input-group",
                                            [
                                              _c("b-form-input", {
                                                staticClass:
                                                  "brunch__text_input",
                                                attrs: {
                                                  placeholder:
                                                    "Введите для поиска"
                                                },
                                                model: {
                                                  value: _vm.filterOrders,
                                                  callback: function($$v) {
                                                    _vm.filterOrders = $$v
                                                  },
                                                  expression: "filterOrders"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "transition",
                                                {
                                                  attrs: { name: "slide-fade" }
                                                },
                                                [
                                                  _vm.filterOrders.length
                                                    ? _c(
                                                        "b-input-group-append",
                                                        [
                                                          _c(
                                                            "b-btn",
                                                            {
                                                              attrs: {
                                                                disabled: !_vm.filterOrders
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.filterOrders =
                                                                    ""
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Очистить")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-1",
                                          attrs: {
                                            horizontal: "",
                                            label: "Статус"
                                          }
                                        },
                                        [
                                          _c(
                                            "b-form-select",
                                            {
                                              attrs: {
                                                disabled: _vm.loadingOrders,
                                                options: _vm.selectStatuses
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.statusUpdated(
                                                    $event
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.filterStatus,
                                                callback: function($$v) {
                                                  _vm.filterStatus = $$v
                                                },
                                                expression: "filterStatus"
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: { slot: "first" },
                                                  domProps: { value: null },
                                                  slot: "first"
                                                },
                                                [_vm._v("-- Все --")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.selectPoints
                                        ? _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-1",
                                              attrs: {
                                                horizontal: "",
                                                label: "Точка"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-form-select",
                                                {
                                                  attrs: {
                                                    disabled: _vm.loadingOrders,
                                                    value: _vm.filterBranch,
                                                    options: _vm.selectPoints
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.restPointUpdated(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { slot: "first" },
                                                      domProps: { value: null },
                                                      slot: "first"
                                                    },
                                                    [_vm._v("-- Все --")]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            id: "checkbox-preorders",
                                            name: "checkbox-preorders",
                                            value: true,
                                            "unchecked-value": false,
                                            disabled: _vm.loadingOrders
                                          },
                                          model: {
                                            value: _vm.showPreordersToday,
                                            callback: function($$v) {
                                              _vm.showPreordersToday = $$v
                                            },
                                            expression: "showPreordersToday"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    Отображать предзаказы оформленные сегодня\n                                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            id: "checkbox-preorders-week",
                                            name: "checkbox-preorders-week",
                                            value: true,
                                            "unchecked-value": false,
                                            disabled: _vm.loadingOrders
                                          },
                                          model: {
                                            value: _vm.showPreordersWeek,
                                            callback: function($$v) {
                                              _vm.showPreordersWeek = $$v
                                            },
                                            expression: "showPreordersWeek"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                  Отображать предзаказы на ближайшую неделю\n                                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            id: "checkbox-order-done",
                                            name: "checkbox-order-done",
                                            value: true,
                                            "unchecked-value": false,
                                            disabled: _vm.loadingOrders
                                          },
                                          model: {
                                            value: _vm.showDoneOrder,
                                            callback: function($$v) {
                                              _vm.showDoneOrder = $$v
                                            },
                                            expression: "showDoneOrder"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Отображать завершенные заказы\n                              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.reloadingOrders === true
                            ? _c("preloader")
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "perfect-scrollbar",
                            {
                              ref: "scrollbar",
                              staticClass: "flex-grow-1 flex-basis-0",
                              attrs: { options: _vm.opsScroll },
                              on: { "ps-scroll-y": _vm.onOrdersScroll }
                            },
                            [
                              _c(
                                "b-list-group",
                                {
                                  ref: "orders_list",
                                  staticClass: "mb-1",
                                  attrs: { flush: "" }
                                },
                                [
                                  _vm.filterOrds.length === 0 &&
                                  !_vm.loadingOrders
                                    ? _c(
                                        "b-card-body",
                                        { staticClass: "text-center" },
                                        [
                                          _vm._v(
                                            "Заказов не найдено\n                            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.filterOrds, function(ord, idx) {
                                    return _c(
                                      "b-list-group-item",
                                      {
                                        key: ord.id,
                                        class: [
                                          "order",
                                          {
                                            activeIt:
                                              _vm.order &&
                                              ord.id === _vm.order.id
                                          },
                                          {
                                            "busy-order":
                                              ord.idWorkerOpened !== null &&
                                              ord.timeOpened !== null &&
                                              _vm.secondsFromNow(
                                                ord.timeOpened
                                              ) < _vm.holdTime,
                                            "opened-by-me-order":
                                              ord.idWorkerOpened !== null &&
                                              ord.idWorkerOpened ===
                                                _vm.userId &&
                                              ord.timeOpened !== null &&
                                              _vm.secondsFromNow(
                                                ord.timeOpened
                                              ) < _vm.holdTime
                                          }
                                        ],
                                        on: {
                                          click: function($event) {
                                            return _vm.changeOrder(ord)
                                          }
                                        }
                                      },
                                      [
                                        _c("order-block", {
                                          key: ord.id,
                                          attrs: {
                                            order: ord,
                                            type: "call-center"
                                          },
                                          on: {
                                            "shown-hide-order": function(
                                              $event
                                            ) {
                                              return _vm.shownHideOrder($event)
                                            },
                                            "on-history-show": function(
                                              $event
                                            ) {
                                              return _vm.addStatusesToOrder(
                                                ord,
                                                idx
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.loadingOrders === true
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-center mt-2"
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          type: "border",
                                          variant: "dark",
                                          small: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Загрузка...")])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          ref: "listOrders",
                          attrs: {
                            "modal-class": "fullSizeModal",
                            "ok-only": "",
                            id: "listOrders",
                            size: "lg"
                          },
                          on: {
                            shown: function($event) {
                              return _vm.$refs.listOrdersComp.updateOrders()
                            }
                          }
                        },
                        [
                          _c("list-orders", {
                            ref: "listOrdersComp",
                            staticClass: "body",
                            attrs: { statusOptions: _vm.statusOptions },
                            on: {
                              "repeat-order": function($event) {
                                return _vm.repeatFromHistory($event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.order
                        ? _c(
                            "b-modal",
                            {
                              ref: "ymapsModal",
                              attrs: {
                                "modal-class": "fullSizeModal",
                                "cancel-title": "Зона определена не верно",
                                title: "Определение точки доставки",
                                id: "deliveryMap",
                                size: "lg"
                              },
                              on: {
                                close: _vm.closeModal,
                                hide: _vm.closeModal,
                                shown: _vm.findPlace
                              }
                            },
                            [
                              _vm.loadingSuggest
                                ? _c(
                                    "div",
                                    [
                                      _c("b-spinner", {
                                        attrs: { type: "grow" }
                                      }),
                                      _vm._v(" Загрузка...")
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.loadingSuggest &&
                              _vm.variantsPositions.length === 0
                                ? _c(
                                    "div",
                                    { staticClass: "info-suggest-not-found" },
                                    [
                                      _vm._v(
                                        "\n                      Указанной улицы не найдено ни в одном населённом пункте"
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n                      Проверьте правильность ввода.\n                    "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.suggestError
                                ? _c(
                                    "div",
                                    { staticClass: "info-suggest-error" },
                                    [
                                      _vm._v(
                                        "\n                      Ошибка при поиске улицы, закройте и откройте заново окно определения местоположения.\n                    "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "perfect-scrollbar",
                                {
                                  staticClass: "scroll-postiton-variants",
                                  attrs: { options: _vm.opsScroll }
                                },
                                _vm._l(_vm.variantsPositions, function(pos) {
                                  return _c("card-location-variant", {
                                    key: pos.sourceValue,
                                    attrs: {
                                      variant: pos,
                                      "selected-variant": _vm.selectedPosition
                                    },
                                    on: {
                                      "selected-variant": function($event) {
                                        _vm.selectedPosition = $event
                                      }
                                    }
                                  })
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "mb-2 mt-2 delivery-cost",
                                  class: {
                                    "delivery-cost_error":
                                      this.order.idZone === null,
                                    "delivery-cost_success":
                                      this.order.idZone !== null
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("b", [_vm._v("Стоимость доставки:")]),
                                    _vm._v(" " + _vm._s(_vm.priceDel))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("b", [_vm._v("Точка:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.order.point
                                            ? _vm.order.point.address
                                            : "Не определена"
                                        )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("b", [_vm._v("Населенный пункт:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.order.settlement
                                            ? _vm.order.settlement
                                            : "Не определен"
                                        )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  class: _vm.ymapsToggled ? null : "collapsed",
                                  attrs: {
                                    "aria-expanded": _vm.ymapsToggled
                                      ? "true"
                                      : "false",
                                    "aria-controls": "map"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.ymapsToggled = !_vm.ymapsToggled
                                    }
                                  }
                                },
                                [_vm._v("Открыть карту")]
                              ),
                              _vm._v(" "),
                              _vm.courierAutoAssignStatus === true &&
                              _vm.ymapsToggled
                                ? _c(
                                    "b-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.createRouteMatrixAndDetermineDistance()
                                        }
                                      }
                                    },
                                    [_vm._v("Построить маршрут")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-collapse",
                                {
                                  attrs: { id: "map" },
                                  model: {
                                    value: _vm.ymapsToggled,
                                    callback: function($$v) {
                                      _vm.ymapsToggled = $$v
                                    },
                                    expression: "ymapsToggled"
                                  }
                                },
                                [
                                  _c("yandex-map", {
                                    staticClass: "my-3",
                                    staticStyle: {
                                      width: "100%",
                                      height: "550px"
                                    },
                                    attrs: {
                                      coords: _vm.ymapsCoords.dynamic,
                                      zoom: "12",
                                      "cluster-options": {
                                        1: { clusterDisableClickZoom: true }
                                      },
                                      controls: [
                                        "trafficControl",
                                        "zoomControl",
                                        "searchControl",
                                        "routePanelControl"
                                      ],
                                      "detailed-controls": {
                                        searchControl: {
                                          provider: _vm.yandexSearchProvider
                                        }
                                      }
                                    },
                                    on: {
                                      "map-was-initialized": _vm.mapInitHandler
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                { slot: "modal-footer" },
                                [
                                  !this.permitDragPoint
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: { variant: "danger" },
                                          on: { click: _vm.permitMovePoint }
                                        },
                                        [_vm._v("Зона определена не верно")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "d-inline-block",
                                      attrs: {
                                        id: "zone-correct",
                                        tabindex: "0"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "success",
                                            disabled:
                                              this.courierAutoAssignStatus ===
                                                true &&
                                              this.ymapsMatrixCreated === false
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.$bvModal.hide(
                                                "deliveryMap"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Зона определена верно")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tooltip",
                                    { attrs: { target: "zone-correct" } },
                                    [
                                      _vm._v(
                                        "Чтобы эта кнопка была активной, нужно: "
                                      ),
                                      _c("br"),
                                      _vm._v("1. Открыть карту; "),
                                      _c("br"),
                                      _vm._v("2. Построить маршрут")
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "warningMutation",
          attrs: {
            id: "warningMutation",
            centered: "",
            visible: _vm.showWarningModal,
            "ok-title": "Да",
            "cancel-title": "Нет",
            "ok-variant": "danger",
            "cancel-variant": "success"
          },
          on: {
            ok: function($event) {
              return _vm.warningModalResult(true)
            },
            cancel: function($event) {
              return _vm.warningModalResult(false)
            }
          }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.warningModalObject ? _vm.warningModalObject.text : ""
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "confirmOrder",
          attrs: {
            id: "confirmOrder",
            title: "Предупреждение",
            centered: "",
            "cancel-title": "Отмена",
            "ok-title": "Продолжить"
          },
          on: {
            ok: function($event) {
              return _vm.setOrder(_vm.nextOrder)
            }
          }
        },
        [
          _vm._v(
            "\n        Заказ был изменён. Совершённые изменения будут утеряны, продолжить?\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "anotherOperatorActive",
          attrs: {
            id: "anotherOperatorActive",
            title: "Ошибка",
            centered: "",
            "ok-only": ""
          }
        },
        [
          _vm._v(
            "\n      Другой оператор уже обрабатывает выбранный заказ\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "prohibitChangeOrder",
          attrs: {
            id: "prohibitChangeOrder",
            title: "Предупреждение",
            centered: "",
            "cancel-title": "",
            "ok-title": "ОК",
            "ok-only": true
          }
        },
        [
          _vm._v(
            "\n        Выбранный заказ уже был подтверждён, его изменение запрещено.\n    "
          )
        ]
      ),
      _vm._v(" "),
      _vm.order
        ? _c(
            "b-modal",
            {
              ref: "orderDeleteProduct",
              attrs: {
                id: "orderDeleteProduct",
                title: "Вы действительно хотите удалить продукты из заказа?",
                "ok-disabled":
                  _vm.order.deletedComment === null ||
                  _vm.order.deletedComment === "",
                centered: "",
                "cancel-title": "Отмена",
                "ok-title": "ОК"
              },
              on: {
                ok: function($event) {
                  return _vm.saveOrder()
                }
              }
            },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0 flex-grow-0",
                  attrs: {
                    label: "Введите причину удаления продуктов:",
                    "label-for": "deletedCause"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "deletedCause",
                      required: "",
                      trim: "",
                      placeholder: "Комментарий"
                    },
                    model: {
                      value: _vm.order.deletedComment,
                      callback: function($$v) {
                        _vm.$set(_vm.order, "deletedComment", $$v)
                      },
                      expression: "order.deletedComment"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isRestManager
        ? _c("cancel-order-modal", {
            ref: "causeCancelOrder",
            attrs: {
              orderId: _vm.order ? _vm.order.id : null,
              onWorkshopNow: _vm.order
                ? _vm.order.workshop &&
                  _vm.order.workshop.nodes &&
                  _vm.order.workshop.nodes.length > 0
                : false,
              statusOptions: _vm.statusOptions,
              repeat: _vm.repeat
            },
            on: { "order-canceled": _vm.orderCanceled }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b65131c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b65131c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderInfo.vue
// module id = null
// module chunks = 